export const MESSAGES = {
  NO_COMPANY_SELECTED: 'No hay empresa seleccionada',
  NO_CONSUMPTION_DATA: 'No se encontraron datos de consumo',
  USER_NOT_FOUND: 'Usuario no encontrado',
  BRANCH_OFFICE_NOT_FOUND: 'Sucursal no encontrada',
  USER_ID_NOT_FOUND: 'ID de usuario no encontrado',
  INVALID_CREDENTIALS: 'Credenciales inválidas',
  BACKEND_NOT_IMPLEMENTED: 'Funcionalidad no disponible',
} as const;
